import { useLayoutEffect } from "react";

const isBrowser = typeof window !== `undefined`;

export const getPosition = (element: Element): DOMRect | null => {
  return element.getBoundingClientRect();
};

export const useScroll = (
  effect: (didResize: boolean) => void,
  deps?: Array<any>
): void => {
  const handleScroll = () => {
    effect(false);
  };

  const handleResize = () => {
    effect(true);
  };

  useLayoutEffect(() => {
    if (!isBrowser) return;

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, deps);
};

export default useScroll;
